import { render } from "./SponsorshipView.vue?vue&type=template&id=7533f1e0&scoped=true"
import script from "./SponsorshipView.vue?vue&type=script&lang=js"
export * from "./SponsorshipView.vue?vue&type=script&lang=js"

import "./SponsorshipView.vue?vue&type=style&index=0&id=7533f1e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7533f1e0"]])

export default __exports__